import superagent from 'superagent';

export default class Request {
	constructor(options) {
		this.req = null;
		this.onStart = null;
		this.onSuccess = null;
		this.onError = null;
		this.url = null;
		this.timeout = 30000;
		this.data = {};
		this.sendType = 'application/json';
		this.responseType = null;
		this.method = 'POST';
		this.headers = {};
		this.link = 'cancel';

		if(typeof options !== 'undefined') {
			Object.entries(options).forEach(([k, v]) => {
				if(k === 'onStart' || k === 'onSuccess' || k === 'onError' || k === 'url' || k === 'timeout'
				|| k === 'data' || k === 'dataType' || k === 'method' || k === 'link' || k === 'headers' || k === 'sendType'
				|| k === 'responseType') {
					this[k] = v;
				}
			}, this);
		}
	}

	get(newData, merge) {
		if(typeof merge === 'undefined') merge = false;
		this.method = 'GET';
		if(typeof newData !== 'undefined') {
			if(merge) {
				this.data = Object.assign(this.data, newData);
			} else {
				this.data = newData;
			}
		}
		this._execute();
	}

	post(newData, merge) {
		if(typeof merge === 'undefined') merge = false;
		this.method = 'POST';
		if(merge) {
			this.data = Object.assign(this.data, newData);
		} else {
			this.data = newData;
		}
		this._execute();
	}

	make(newData, merge) {
		if(typeof merge === 'undefined') merge = false;
		if(merge) {
			this.data = Object.assign(this.data, newData);
		} else {
			this.data = newData;
		}
		this._execute();
	}

	_execute() {
        	if(this.link === 'cancel' && this.req) {
			this.req.abort();
		}
		// TODO handle link=chain

		if(this.onStart) this.onStart();

        	this.req = null;
		this.req = superagent(this.method, this.url)
			.set(this.headers)
			.type(this.sendType)
			.timeout({response: this.timeout, deadline: this.timeout})

		if(this.method === 'GET' || this.method === 'HEAD') {
			this.req.query(this.data);
		} else {
			this.req.send(this.data);
		}

		if(this.responseType) {
			this.req.responseType(this.responseType);
		}

		// Must be here because then() triggers the actual request
		this.req.then(function(resp) {
			// SUCCESS
			//if(resp.error) 
			if(this.onSuccess) this.onSuccess(resp);
		}.bind(this))
		.catch(function(err) {
			// Ignore Aborted requests
			if(this.link === 'cancel' && err.code === 'ABORTED') {
				return true;
			}
			// ERROR
			if(this.onError) this.onError(err);
		}.bind(this));
	}

	cancel() {
		this.xhr.abort();
	}
}